import { useExperiment } from '@rea-argonaut/experiment';
import { useEffect } from 'react';

export type OptimizelyVariables = { [variableKey: string]: unknown };

export const useOptimizelyExperiment = (
  experimentId: string,
  customEventId?: string,
): {
  variation: string | null;
  trackCustomEvent: () => void;
  variables: OptimizelyVariables | null;
} => {
  const { getVariation, activate, track, getExperimentVariables } = useExperiment(experimentId);

  useEffect(() => {
    activate();
  }, [activate]);

  const variation = getVariation();

  const trackCustomEvent = () => {
    if (customEventId) {
      track(customEventId);
    }
  };

  const variables = getExperimentVariables();

  return { variation, trackCustomEvent, variables };
};

export const useOptimizelyExperimentVariant = (experimentId: string): string | null => {
  const { getVariation } = useExperiment(experimentId);
  return getVariation();
};
